import { Button, InfoModal, LoadingSpinner } from "@newsela/angelou";
import { isEmpty } from "@s-libs/micro-dash";
import PropTypes from "prop-types";

import globalToasterRef from "@/base/globalToasterRef";
import useClassroomRosterChoicePost from "../useClassroomRosterChoicePost";
import useClassroomRosterSyncGetList from "../useClassroomRosterSyncGetList";
import { modalCss } from "./ClassroomSwitchSyncModal.style";
import {
  EVENT_TOAST_FAIL,
  getProviderName,
} from "./ClassroomSwitchSyncModal.utils";

const propTypes = {
  user: PropTypes.shape({
    auth_type: PropTypes.string.isRequired,
  }).isRequired,
  rosterChoice: PropTypes.shape({
    id: PropTypes.number.isRequired,
    provider: PropTypes.string.isRequired,
  }),
  modalProps: PropTypes.object.isRequired,
  setActive: PropTypes.func.isRequired,
  onRosterChoiceChanged: PropTypes.func.isRequired,
};

const ClassroomSwitchSyncModal = ({
  user,
  rosterChoice,
  modalProps,
  setActive,
  onRosterChoiceChanged,
}) => {
  const { data: rosterSyncList = [], loading: loadingRosterSyncList } =
    useClassroomRosterSyncGetList();
  const [postRosterChoice, { loading: isSaving }] =
    useClassroomRosterChoicePost();
  const isLoading = loadingRosterSyncList || isSaving;

  const onSubmit = async () => {
    const response = await postRosterChoice({ provider: user.auth_type });
    if (response.error) {
      globalToasterRef.current.displayToast(EVENT_TOAST_FAIL);
    } else {
      onRosterChoiceChanged(response.data);
      setActive(false);
    }
  };

  const infoModalProps = {
    title: `Sync with ${getProviderName(user.auth_type)}?`,
    labelId: "SyncSwitch",
    __cssFor: modalCss,
    footer: (
      <>
        <Button
          flavor={Button.flavors.secondary}
          onClick={() => setActive(false)}
        >
          Cancel
        </Button>
        <Button
          flavor={Button.flavors.primary}
          disabled={isLoading}
          onClick={onSubmit}
        >
          Confirm sync
        </Button>
      </>
    ),
    ...modalProps,
  };

  if (isLoading) {
    return (
      <InfoModal {...infoModalProps}>
        <LoadingSpinner />
      </InfoModal>
    );
  }

  return (
    <InfoModal {...infoModalProps}>
      <p>
        You'll still have access to these classes—but won't be able to sync them
        with their previous LMS: {getProviderName(rosterChoice.provider)}.
      </p>
      {!isEmpty(rosterSyncList) && (
        <ul>
          {rosterSyncList.map((sync) => (
            <li key={sync.id}>{getProviderName(sync.provider)}</li>
          ))}
        </ul>
      )}
      <p>You can switch to syncing with a previous or new LMS at any time.</p>
    </InfoModal>
  );
};

ClassroomSwitchSyncModal.propTypes = propTypes;

export default ClassroomSwitchSyncModal;
